import React, { forwardRef, memo, useState } from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { useParams } from 'react-router-dom';
import { useDataProvider, useNotify } from 'react-admin';
import { Form } from 'react-final-form';

import { Dialog } from 'components/common';
import { Input } from 'components/form';

const CancelAchTransactionField = forwardRef((props: any, ref: any) => {
  const { record, hideAction } = props;

  const { id } = useParams();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  if (hideAction) {
    return null;
  }

  const handleCancelTransaction = async () => {
    try {
      await dataProvider.create('cancelAchTransaction', {
        userId: id,
        data: {
          groupTransactionId: record.id,
          paymentIntent: record.details.paymentIntentId,
        },
      });
      notify('Transaction cancelled', 'success');
    } catch (error: any) {
      notify("Transaction couldn't be cancelled", 'error');
    } finally {
      handleCloseDialog();
    }
  };

  return (
    <>
      <MenuItem ref={ref} onClick={handleOpenDialog}>
        Cancel payment
      </MenuItem>

      {openDialog && (
        <Form
          onSubmit={handleCancelTransaction}
          initialValues={{
            cancellationReason: '',
          }}
          render={({ submitting, handleSubmit }) => {
            return (
              <Dialog
                open={openDialog}
                title="Cancel ACH transaction"
                onCancel={handleCloseDialog}
                onConfirm={handleSubmit}
                submitting={submitting}>
                <Typography>Are you sure you want to cancel this ACH transaction?</Typography>

                <Input name="cancellationReason" label="Cancel" />
              </Dialog>
            );
          }}
        />
      )}
    </>
  );
});

export default memo(CancelAchTransactionField);
